/**
 * @module businessComponents\mdl\siteComponent\cascaderSite
 */
import Vue from "vue";
import Component from "vue-class-component";
import SiteComponent from "../siteComponent/siteComponent";
import AreaComponent from "../siteComponent/areaComponent/areaComponent";
import StructBase from "../siteComponent/structBase";
import { Watch } from "vue-property-decorator";

@Component({
  components: {
    SiteComponent,
    AreaComponent
  }
})
export default class CascaderSite extends StructBase {
  private site = "";
  private areas = [];

  private get Result() {
    if (this.areas && this.areas.length > 0) {
      return this.areas;
    }
    return [this.site];
  }

  @Watch("Result")
  private observeResult() {
    this.$emit("input", this.Result);
  }
}
